import { Component, OnDestroy, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { clientFilter, ClientList } from '../../models/client.model'
import { Subscription } from 'rxjs'
import { SharedService } from 'src/app/shared/services/shared.service'
import { ClientService } from '../../services/client.service'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
	selector: 'app-client-list',
	templateUrl: './client-list.component.html',
	styleUrls: ['./client-list.component.scss'],
})
export class ClientListComponent implements OnInit, OnDestroy {
	subscription = new Subscription()
	clientFilter: clientFilter = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		searchText: '',
		countryId: null,
	}
	totalCount = 0
	noDataFoundMessage!: string
	filterCount = 0
	clients: ClientList[] = []
	constructor(
		public translate: TranslateService,
		private SharedService: SharedService,
		private clientService: ClientService,
		private router: Router,
		public ActivatedRoute: ActivatedRoute
	) {
		this.SharedService.headerTitle.next(`CLIENT.CLIENT_LIST.PAGE_TITLE`)
	}

	ngOnInit(): void {
		this.subscription.add(
			this.ActivatedRoute.queryParams.subscribe((res) => {
				this.clientFilter.paging.pageNumber = res['page'] || 1
				this.clientFilter.paging.pageSize = res['count'] || 10
				this.getClints()
				this.SharedService.handleBreadCrumb('clients', true, {
					name: '',
					id: null,
					url: '/layout/clients',
					queryParams: { ...res },
				})
			})
		)
	}

	getClints(search = false, filter: any = null) {
		search ? (this.clientFilter.paging.pageNumber = 1) : null
		filter ? (this.clientFilter = { ...this.clientFilter, ...filter }) : null
		this.subscription.add(
			this.clientService
				.getClientList(this.clientFilter)
				.subscribe((res: any) => {
					this.clients = res.result?.items
					this.totalCount = res?.result?.totalCount
					this.clientFilter.searchText
						? (this.noDataFoundMessage = 'GENERAL.NO_SEARCH_FOUND')
						: (this.noDataFoundMessage = 'CLIENT.CLIENT_LIST.NO_BOOKING')
				})
		)
	}

	pageChanged(pageNumber: number, pageCount: number) {
		this.router.navigate(['/layout/clients'], {
			queryParams: {
				page: pageNumber,
				count: pageCount,
			},
		})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
